import { render } from "./TicketsCreate.vue?vue&type=template&id=27ee5b26"
import script from "./TicketsCreate.vue?vue&type=script&lang=js"
export * from "./TicketsCreate.vue?vue&type=script&lang=js"

import "./TicketsCreate.vue?vue&type=style&index=0&id=27ee5b26&lang=scss"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__